module.exports = __webpack_public_path__ + "img/hr-red-croton-09.8ede5ce9.png";